/**
 *
 * CourseCard
 *
 */

import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import moment, { localeFr } from 'utils/moment/momentLocale';
// import { Link, useHistory } from 'react-router-dom';

// styles
import './style.scss';

// antd component
//import { Card } from 'antd';
//const { Meta } = Card;

// icons
//import CustomIcons from 'components/CustomIcons';

function CourseCard({
  data,
  // default props
  className,
  ...rest
}) {
  const childClassNames = classNames('course-card', className);

  return (
    data && (
      <div className={childClassNames}>
        <div className="course-card__top">
          <div className="column">
            <h4>{data?.subject?.name}</h4>
          </div>
          {data?.class_info?.title && (
            <div className="column">{data?.class_info?.title}</div>
          )}
        </div>
        <div className="course-card__bottom">
          <div className="column">
            <span className="course-time">
              {`${data?.course_week}, ${moment(data?.course_time_start).format(
                'H:mm',
              )} - ${moment(data?.course_time_end).format('H:mm')}`}
            </span>
          </div>
          <div className="column">
            S. {data?.class_room ? data?.class_room : '--'}
          </div>
        </div>
      </div>
    )
  );
}

CourseCard.defaultProps = {};
CourseCard.propTypes = {
  data: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.bool,
    PropTypes.string,
  ]),
};

export default memo(CourseCard);
